<template>
  <div>
    <div
      v-if="loadingDetails"
      class="loading"
    >
      <a-spin tip="loading" />
    </div>
    <div v-else>
      <a-table
        :columns="columns"
        :pagination="false"
        :data-source="invoiceListData"
        class="table-list"
      >
        <div
          slot="type"
          slot-scope="type, record"
          class="order-cell"
        >
          <span v-if="record.type===2">{{ $t('message["1562"]') }}</span>
          <span v-else>{{ $t('message["1563"]') }}</span>
        </div>
        <div
          slot="invoicetitle"
          slot-scope="invoicetitle, record"
          class="order-cell"
        >
          <span>{{ record.invoicetitle }}</span>
        </div>
        <div
          slot="content_type"
          slot-scope="content_type, record"
          class="order-cell"
        >
          <span v-if="record.content_type===1">{{ $t('message["1363"]') }}</span>
          <span v-else>{{ $t('message["465"]') }}</span>
        </div>
        <div
          slot="addtime"
          slot-scope="addtime, record"
          class="order-cell date-time-cell"
        >
          <span>{{ timestampToTime(record.addtime, '-').date }}</span>
          <p>{{ timestampToTime(record.addtime, '-').time }}</p>
        </div>
        <div
          slot="status"
          slot-scope="status, record"
          class="order-cell"
        >
          <span
            v-if="record.status === 0"
            class="wait-for-pay"
          >{{ $t('message["1049"]') }}</span>
          <span
            v-else-if="record.status === 2"
          > {{ $t('message["1455"]') }}</span>
          <span
            v-else
          >{{ $t('message["1462"]') }}</span>
        </div>
        <div
          slot="title_type"
          slot-scope="title_type, record"
          class="order-cell"
        >
          <a
            href="javascript:;"
            @click="viewItemInfo(record.id)"
          >{{ $t('message["1316"]') }}</a>
        </div>
      </a-table>
      <order-info-dia
        ref="orderInfoDialog"
        :order-data="itemData"
      />
      <div class="loading">
        <a-button
          v-if="invoiceListData.length >=10 "
          :loading="loading"
          :disabled="loading"
          class="load-more-btn"
          @click="getListDatas"
        >
          {{ $t('message["472"]') }}
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import OrderInfoDia from './InvoiceItem'
import { cloneDeep } from 'lodash'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import { timestampToTime } from '@/store/account/scripts'

export default {
  components: {
    OrderInfoDia
  },
  data () {
    return {
      page: 2,
      loading: false,
      itemData: {}
    }
  },
  computed: {
    ...mapState('account/invoice', ['loadingDetails', 'invoiceDatas']),
    ...mapGetters('account/invoice', ['invoiceListData']),
    columns () {
      const columns = [{
        dataIndex: 'amount',
        key: 'amount',
        title: this.$t('message["526"]')
      }, {
        title: this.$t('message["270"]'),
        key: 'type',
        dadaIndex: 'type',
        scopedSlots: { customRender: 'type' }
      }, {
        title: this.$t('message["1160"]'),
        key: 'invoicetitle',
        dadaIndex: 'invoicetitle',
        scopedSlots: { customRender: 'invoicetitle' }
      }, {
        title: this.$t('message["271"]'),
        key: 'content_type',
        dadaIndex: 'content_type',
        scopedSlots: { customRender: 'content_type' }
      }, {
        title: this.$t('message["1042"]'),
        key: 'addtime',
        dadaIndex: 'addtime',
        scopedSlots: { customRender: 'addtime' },
        width: 120
      }, {
        title: this.$t('message["1646"]'),
        key: 'status',
        dadaIndex: 'status',
        scopedSlots: { customRender: 'status' }
      },
      {
        title: this.$t('message["79"]'),
        key: 'title_type',
        dadaIndex: 'title_type',
        scopedSlots: { customRender: 'title_type' }
      }
      ]
      return columns
    }
  },
  async mounted () {
  },
  methods: {
    timestampToTime,
    ...mapMutations('account/invoice', ['setInvoiceDatas']),
    ...mapActions('account/invoice', ['fetchOrderListDatas', 'fetchInvoiceDetailDatas', 'fetchPay']),
    async getListDatas () {
      this.loading = true
      let arr = cloneDeep(this.invoiceDatas)
      const chain = await this.fetchOrderListDatas()
      chain.params({ isinvoice: 0, page: this.page })
        .onSuccess(res => {
          if (res.length) {
            arr.push(...this.invoiceDatas)
            this.setInvoiceDatas(arr)
            this.page++
          } else {
            this.setInvoiceDatas(arr)
            // alert('已加载完毕！')
            this.$message.warning('已加载完毕！')
          }
        })
        .fetch()
      this.loading = false
    },
    async viewItemInfo (id) {
      const chain = await this.fetchInvoiceDetailDatas()
      chain.params({ id: id })
        .onSuccess(res => {
          this.itemData = res
          this.$refs.orderInfoDialog.changeVisible(true)
        })
        .fetch()
    }
  }
}
</script>
<style lang="scss" scoped>
  .invoice-btn-box {
    margin: 24px 0 ;
    em {
      color: #42c27e;
      font-style: normal;
    }
  }
  .date-time-cell {
    font-size: 12px;
    p {
      color: #999;
    }
  }
  .wait-for-pay {
    color: #f6a953;
  }
</style>
